var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatedNewFete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    y: 0.986,
    fill: "#1E0AF5",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.858 7.978.052.046 4.636 4.636a.544.544 0 0 1 .058.705.546.546 0 0 1-.192.166l-.064.027-5.673 2.091c-1.067.394-2.105-.609-1.781-1.674l.027-.08 2.09-5.673a.544.544 0 0 1 .79-.282l.057.038ZM8.741 9.4l-1.794 4.873a.272.272 0 0 0 .306.363l.044-.012 4.872-1.796L8.741 9.4Zm5.051.952c.498.026 1.18.13 1.774.487a.546.546 0 0 1-.506.967l-.056-.03c-.373-.224-.85-.311-1.27-.333a4.2 4.2 0 0 0-.518.002l-.173.017a.546.546 0 0 1-.153-1.082c.299-.039.601-.048.902-.029M14.9 8.83a.545.545 0 0 1 .417.897.547.547 0 0 1-.354.192l-.063.004h-.387a.546.546 0 0 1-.064-1.09l.064-.003h.387Zm-1.74-.42a.545.545 0 0 1 .045.721l-.045.052-.58.58a.545.545 0 0 1-.817-.722l.045-.051.58-.58a.548.548 0 0 1 .772 0Zm-1.413-2.877c.245.736.113 1.541-.04 2.104-.091.35-.218.692-.377 1.018a.546.546 0 1 1-.978-.488c.127-.262.228-.536.3-.818.125-.454.187-.947.092-1.352l-.034-.118a.546.546 0 1 1 1.037-.346Zm2.958 1.332a.547.547 0 0 1 0 .773l-.386.386a.541.541 0 0 1-.6.126.548.548 0 0 1-.173-.898l.387-.387a.546.546 0 0 1 .772 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedNewFete);
export default __webpack_public_path__ + "static/media/created-new-fete.aece4e758621bc92e0bdf537033b4766.svg";
export { ForwardRef as ReactComponent };